import router from '@/router/index.router';
import useSelfService from '@/services/SelfService';
import useUiService from '@/services/UiService';
import { Bus, isTouch, itemHas, useResponsive } from '@orion.ui/orion';
import { onBeforeMount, onBeforeUnmount, onMounted, onUnmounted } from 'vue';
// import useFeatureFlagService from '@/services/FeatureFlagService';
import SelfEntity from '@/entity/SelfEntity';
import { useDateI18n } from '@/utils/date-i18n';
import { Reactive } from '@/utils/decorators';
import { useI18n } from 'vue-i18n';

export default abstract class BaseSetup {

	readonly router = router;
	readonly ui = useUiService();
	readonly responsive = useResponsive();
	// readonly featureFlag = useFeatureFlagService();
	readonly isTouch = isTouch();
	readonly itemHas = itemHas;
	readonly $t = useI18n().t;
	readonly $n = useI18n().n;
	readonly $d = useI18n().d;
	readonly i18nDate = useDateI18n();

	@Reactive private readonly baseState = { registeredEvents: [] as string[] };

	get self () { return useSelfService().self }
	get route () { return this.router.currentRoute.value }
	get publicInstance () { return {} }

	constructor () {

		onBeforeMount(() => {
			this.onBeforeMountAsync();
		});

		onMounted(() => {
			this.onMounted();
		});

		onBeforeUnmount(() => {
			this.onBeforeUnmount();
		});

		onUnmounted(() => {
			if (this.baseState.registeredEvents.length) {
				this.baseState.registeredEvents.forEach(ev => Bus.off(ev));
			}

			this.onUnmounted();
		});
	}

	protected async onBeforeMountAsync () {}
	protected onMounted () {}
	protected onBeforeUnmount () {}
	protected onUnmounted () {}
	registerBusEvent (evName: string, cb: (...arg: any) => void) {
		const setupName = (this as any).constructor.name;
		const busEventName = `${setupName}:${evName}`;
		this.baseState.registeredEvents.push(busEventName);
		Bus.on(busEventName, (...arg) => cb(...arg));
	}

	organizationGuard (): this is { self: typeof SelfEntity & { organization: { id: number } } } {
		return !!this.self.organization?.id;
	}

}
